import './print-trim.scss';
import React from 'react';
import PrintTrimHeader from './header/print-trim.header';
import PrintTrimFooter from './footer/print-trim.footer';
import PrintTrimMenu from './menu/print-trim-menu';
import TrimToolbar from './toolbar/trim.toolbar';
import PrintTrimEditor from './print-trim.editor/print-trim.editor';
import usePrintTrim from './hooks/use-print-trim';
import { TrimmingController } from '../../layout/toolbar/layout.trimming-controller';
import { TrimTrimmingController } from './toolbar/trim.trimming-controller';
import { LoadingPopup } from '../../../ui/loading/loading-popup';


const PrintTrim = () => {
  const {
    trimMenu,
    textPos,
    menuParam,
    template,
    structure,
    selectImage,
    handlerCloseTrimmingController,
    connectingMessage,
    connectingMessage2,
    dialogs,
    item,
    printDetail,
    deliveryType,
    lastName,
    isRotateTemp,
  } = usePrintTrim();

  return (
    <div className="trim">
      <div className="trim__header_wrap">
        <div>
          {/* ヘッダー */}
          <PrintTrimHeader name={lastName} delivery={deliveryType}/>
        </div>
        <div>
          {/* メインメニュー */}
          <PrintTrimMenu initMenu={menuParam.current} item={item} />
        </div>
      </div>


      <div className="trim__body">
        {/* ツールバー */}
        <TrimToolbar
          textPos={textPos}
          menuParam={menuParam.current}
          isRotateTemp={isRotateTemp}
        />
        {/* テンプレート編集 */}
        <div
          id="edit-dummy"
          className={`trim__body__edit  ${menuParam.current.screenColor}`}
        >
          {trimMenu ? <TrimTrimmingController closeCallback={handlerCloseTrimmingController} /> : <></>}
          <PrintTrimEditor
            template={template}
            structure={structure}
            selectImage={selectImage}
            initMenu={menuParam.current}
            isRestore={false}
            callbackRestore={() => {
            }}
          />
          {/*{trimMenu ? <TrimmingController*/}
          {/*  kijshopCd={kijshopCd}*/}
          {/*  closeCallback={handlerCloseTrimmingController}*/}
          {/*/> : <></>}*/}
          {/*<LayoutEditTemplate*/}
          {/*  initMenu={menuParam}*/}
          {/*  isRestore={isRestore}*/}
          {/*  callbackRestore={() => {*/}
          {/*    callbackRestore();*/}
          {/*  }}*/}
          {/*  xml={xml}*/}
          {/*  pageTypeIdArr={pageTypeIdArr}*/}
          {/*/>*/}
        </div>
        {/* レイアウト一覧 */}
        {/* デザイン確認用テスト配列のため、pageNum が key に利用されてるのでログにエラー出ています。 */}
        {/*<LayoutImagePreview*/}
        {/*  isFullWidth={print === 'list'}*/}
        {/*  thumbSizeRate={print === 'list' ? previewThumbSizeRate : undefined}*/}
        {/*  menuParam={menuParam}*/}
        {/*  initCallback={handlerChangeMenuParam}*/}
        {/*  viewPageType={pageTypeIdArr}*/}
        {/*/>*/}

      </div>

      <div className="trim__footer">
        {/* フッター */}
        <PrintTrimFooter printDetail={printDetail} />
      </div>
      {(connectingMessage && !dialogs.length) ? (<LoadingPopup label={connectingMessage} />) : (<></>)}
      {(connectingMessage2 && !dialogs.length) ? (<LoadingPopup label={connectingMessage2} />) : (<></>)}
    </div>
  );
};

export default PrintTrim;
